import { createFileRoute } from '@tanstack/react-router';
import { zodValidator } from '@tanstack/zod-adapter';
import { z } from 'zod';
import { AlertCircle } from 'lucide-react';

import { queryClient } from '~app/query-client';

import { getStudioLogoImageOptions } from '~entities/studios/api/get-studio-logo-image';

import { LoginPage } from '~pages/login';

const loginSearchParamSchema = z.object({
  id: z.string().optional(),
  redirect: z.string().optional(),
});

const Component = () => {
  const { id, redirect } = Route.useSearch();

  if (!id) {
    return (
      <div className='flex h-screen w-screen items-center justify-center bg-gray-50'>
        <div className='text-center max-w-md px-8'>
          <div className='mb-6 flex justify-center'>
            <div className='rounded-full bg-blue-100 p-6'>
              <AlertCircle className='size-16 text-blue-600' strokeWidth={2} />
            </div>
          </div>
          <h1 className='mb-3 text-2xl font-semibold text-gray-900'>
            We couldn't complete this action
          </h1>
          <p className='text-gray-600'>
            If the problem continues, please contact support.
          </p>
        </div>
      </div>
    );
  }

  return <LoginPage locationId={id} redirect={redirect} />;
};

export const Route = createFileRoute('/login')({
  validateSearch: zodValidator(loginSearchParamSchema),
  beforeLoad: async ({ search, preload }) => {
    const { id } = search;
    // Preload studio logo image if locationId is available
    if (id) {
      try {
        const options = getStudioLogoImageOptions({ studioId: id });
        await queryClient.ensureQueryData(options);
      } catch (error) {
        // Allow the route to load even if logo image fails to fetch
        console.error('Failed to preload studio logo:', error);
      }
    }

    return {
      maxAge: preload ? 5 * 60 * 1000 : 0, // Preloaded data stays valid for 5 minutes
    };
  },
  component: Component,
});
